<template>
  <v-card
      class="px-3 py-4 oder-box-products"
      outlined
      tile
  >
    <div class="align-center d-flex justify-space-between">
      <div
          style="color: #ac0606; font-weight: 600; font-size: 14px"
          class="d-flex align-center pl-3 mb-6"
      >
        <div style="width: 150px">Sản phẩm combo</div>
        <div class="d-flex pl-6">
          <v-checkbox
              label="Bán mới"
              hide-details
              class="table-layout-checkbox ma-0 pa-0"
              v-model="product.isNew"
              :disabled="isDetailOrder"
              @change="clickNew(product)"
          />
          <v-checkbox
              label="Gia hạn"
              hide-details
              class="table-layout-checkbox ma-0 pa-0 ml-6"
              v-model="product.isExtend"
              :disabled="isDetailOrder"
              @change="clickExtend(product)"
          />
        </div>
      </div>
      <div  v-if="!isDetailOrder" class="d-flex">
        <div @click="deleteProduct(product, indexProd)" class="cursor-pointer">
          <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M4.4987 0.927734V1.76107H0.332031V3.42773H1.16536V14.2611C1.16536 14.7031 1.34096 15.127 1.65352 15.4396C1.96608 15.7521 2.39 15.9277 2.83203 15.9277H11.1654C11.6074 15.9277 12.0313 15.7521 12.3439 15.4396C12.6564 15.127 12.832 14.7031 12.832 14.2611V3.42773H13.6654V1.76107H9.4987V0.927734H4.4987ZM2.83203 3.42773H11.1654V14.2611H2.83203V3.42773ZM4.4987 5.0944V12.5944H6.16536V5.0944H4.4987ZM7.83203 5.0944V12.5944H9.4987V5.0944H7.83203Z"
                fill="#AC0606"
            />
          </svg>
        </div>
      </div>
    </div>
    <v-row>
      <v-col cols="12">
        <v-simple-table class="table-layout table-order-custom-tutor">
          <thead>
          <tr>
            <th
                class="col-product text-left"
                style="font-size: 12px !important;width: 75% !important;"
            >
              <div class="d-flex justify-space-between">
                <div>SẢN PHẨM</div>
                <div
                    style="color: #0575ff; cursor: pointer"
                    class="d-flex"
                    @click="viewDetailCombo(product.productId)"
                >
                  <v-icon class="mx-2" style="color: #0575ff"
                  >mdi-information</v-icon
                  ><span class="my-auto">Chi tiết combo</span>
                </div>
              </div>
            </th>
            <th class="col-total text-left" style="font-size: 12px !important;width: 25% !important;">ĐƠN GIÁ</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Sản phẩm ${indexProd + 1}`"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :items="product.products"
                    :error-messages="errors"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn"
                    label=""
                    style="padding: 0 !important; font-size: 14px !important;"
                    auto
                    :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '310',
                          }"
                    @change="onSelectProduct(product)"
                    v-model="product.productId"
                    :disabled="isDetailOrder"
                >
                  <template slot="selection" slot-scope="data">
                            <span v-if="innerWidth > 1440">{{
                                data.item.name.length > 120
                                    ? `${data.item.name.slice(0, 120)}...`
                                    : data.item.name
                              }}</span>
                    <span v-else>{{
                        data.item.name.length > 40
                            ? `${data.item.name.slice(0, 40)}...`
                            : data.item.name
                      }}</span>
                  </template>
                  <template slot="item" slot-scope="data">
                    <div>
                      <span style="font-weight: bold; font-size: 14px">{{ data.item.name }}</span>

                      <div class="text-muted d-flex">
                        <v-icon color="#564F4C">mdi-circle-small</v-icon>
                        <span style="font-style: italic; font-size: 10px">
                                  <span v-if=" data.item.skuDuos &&data.item.skuDuos.length "
                                  >Khoá học ({{ data.item.skuDuos.length }})
                                    {{
                                      data.item.skuTutors &&
                                      data.item.skuTutors.length
                                          ? ", "
                                          : ""
                                    }}
                                  </span>
                                  <span v-if="data.item.skuTutors &&data.item.skuTutors.length "
                                  >Gia sư ({{ data.item.skuTutors.length }})
                                    {{
                                      data.item.skuArtifacts &&
                                      data.item.skuArtifacts.length
                                          ? ", "
                                          : ""
                                    }}</span
                                  >
                                  <span
                                      v-if="
                                      data.item.skuArtifacts &&
                                      data.item.skuArtifacts.length
                                    "
                                  >Hiện vật ({{
                                      data.item.skuArtifacts.length
                                    }})</span
                                  >
                                  <span
                                      v-if="
                                      data.item.skuDuos &&
                                      !data.item.skuDuos.length &&
                                      data.item.skuTutors &&
                                      !data.item.skuTutors.length
                                    "
                                  >Không có sản phẩm</span
                                  >
                                </span>
                      </div>
                      <div class="text-muted d-flex">
                        <v-icon color="#564F4C">
                          mdi-circle-small
                        </v-icon>
                        <span
                            style="font-style: italic; font-size: 10px"
                            v-if="
                                    data.item.subjectIdList &&
                                    !data.item.subjectIdList.length
                                  "
                        >Không có môn học</span
                        >
                        <span
                            style="font-style: italic; font-size: 10px"
                            v-for="(subject, index) in data.item
                                    .subjectIdList"
                            :key="'subject' + index"
                        >{{ subjectObj[subject] }}
                                  {{
                            index === data.item.subjectIdList.length - 1
                                ? ""
                                : ", "
                          }}</span
                        >
                      </div>
                    </div>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </td>
            <td class="text-left" style="padding-top: 0px !important;">
              <div style="border-bottom: 1px solid #d2d2d2;padding-bottom: 4px"
                   v-if="product.priceType && product.priceType === 'unchanged'"
              >
                {{
                  product.price || product.price === 0
                      ? formatCurrency(product.price)
                      : '-'
                }}
              </div>
              <validation-provider
                  v-else
                  v-slot="{ errors }"
                  :name="`Đơn giá ${indexProd + 1}`"
                  :rules="{
                    required: true,
                    max_value: product.maxPrice,
                    min_value: product.minPrice,
                  }"
              >
                <v-text-field
                    label=""
                    :error-messages="errors"
                    :disabled="isDetailOrder"
                    :placeholder="
                      product.productId
                        ? `${formatCurrency(
                            product.minPrice
                          )} - ${formatCurrency(product.maxPrice)}`
                        : 'Nhập số tiền'
                   "
                    dense
                    style="padding-top: 0 !important;"
                    type="number"
                    v-model="product.price"
                ></v-text-field>
              </validation-provider>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import {formatCurrency} from "../../../helper/FuncProduct";

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    indexProd: {
      type: Number,
      default: 0,
    },

    subjectObj: {
      type: Object,
      default: () => ({}),
    },
    skuCombos: {
      type: Array,
      default: () => [],
    },
    innerWidth: {
      type: Number,
      default: 0,
    },
    isDetailOrder: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatCurrency,
    onSelectProduct(product) {
      const productSelected = product.products.find(
          (item) => item.id === product.productId
      );
      product.productID = productSelected.productId;
      product.productName = productSelected.name;
      if (product.type === "combo") product.quantity = 1;
      product.productCode = productSelected.code;
      product.campaigns = [];

      if (productSelected.pricePolicies.length) {
        product.priceType = productSelected.pricePolicies[0].priceType;
        product.price = null;
        if (productSelected.pricePolicies[0].priceType == 'unchanged') {
          product.price = productSelected.pricePolicies[0].minPrice;
        }else if(productSelected.pricePolicies[0].priceType == 'custom') {
          product.price = productSelected.pricePolicies[0].maxPrice;
        }
        product.maxPrice = productSelected.pricePolicies[0].maxPrice;
        product.minPrice = productSelected.pricePolicies[0].minPrice;
      }else {
        product.price =  productSelected.orgPrice;
      }
    },
    clickNew(product) {
      product.isExtend = false;
      product.campaigns = [];
    },
    clickExtend(product) {
      product.isNew = false;
      product.campaigns = [];
    },
    deleteProduct(product, index) {
      this.$emit("deleteProduct", { product, index });
    },

    viewDetailCombo(id) {
      this.$emit("viewDetailCombo", id);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__control {
  min-height: 10px;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 10px 12px !important;
  padding-bottom: 0 !important;
}
.price {
  background: #d9d9d9;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 5px;
  font-weight: 400;
  height: 38px;
  line-height: 28px;
  border-radius: 4px;
}
::v-deep
.v-text-field--outlined.v-input--dense.v-text-field--outlined
> .v-input__control
> .v-input__slot {
  min-height: 38px !important;
}

.table-order-custom-tutor {
  th {
    min-width: 100px !important;
    padding-bottom: 0 !important;
    height: 24px !important;
  }
  .col-program {
    width: 240px;
  }
  .col-teacher {
    width: 100px;
  }
  .col-package {
    width: 120px;
  }
  .col-product {
    width: 210px;
  }
  .col-count {
    min-width: 60px !important;
    width: 85px !important;
  }
  .col-price {
    width: 150px;
  }
  .col-discount {
    width: 100px;
  }
  .col-total {
    width: 100px;
  }
  .col-child {
    min-width: 120px !important;
    width: 120px !important;
  }
  .text-muted {
    color: #564f4c;
    font-size: 10px;
  }
}
.table-layout {
  th {
    border-bottom: none !important;
  }
}
.select-customer ::placeholder {
  color: rgb(172, 6, 6) !important;
  font-style: italic;
  font-size: 13px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
